import { I18n } from "../services/I18n";
import "./generated/site-translations-ro";
import common_ro from "../../../../../libs/ps/restaumatic-common/locales/ro.json";
import core_types_sites_ro from "../../../../../libs/ps/restaumatic-core-types-sites/locales/ro.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  ro: { _core_types_sites: core_types_sites_ro },
});
I18n.translations = I18n.extend(I18n.translations, {
  ro: { _common: common_ro },
});
